module.exports = __webpack_public_path__ + "img/family.43d921a5.png";